import { render, staticRenderFns } from "./IvyClients.vue?vue&type=template&id=56b806e5&"
import script from "./IvyClients.vue?vue&type=script&lang=js&"
export * from "./IvyClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports